// Skip ServiceWorker registration in development with Vite dev server
// ServiceWorker intercepts can conflict with Vite HMR
const isDevelopment = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1' ||
                      window.location.port === '3000' ||
                      window.location.port === '3036';

if (navigator.serviceWorker && !isDevelopment) {
  navigator.serviceWorker.register('/serviceworker.js', { scope: './' })
    .then(function(reg) {
      console.log('[Companion]', 'Service worker registered!');
    });
} else if (navigator.serviceWorker && isDevelopment) {
  // Unregister any existing service workers in development
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('[Companion]', 'Service worker unregistered for development');
    }
  });
}
